export const SIM_UNVERIFIED = "SIM_UNVERIFIED";
export const SIM_VERIFIED = "SIM_VERIFIED";
export const SIM_ERROR = "SIM_ERROR";
